<div style="position: relative; width: 100%; min-height: 80vh;">
    <iframe
        [src]="url_mesa_ayuda"
        style="border: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%;" >
    </iframe>
</div>